/**
 * @fileoverview Model for the backend response to a request to render the Specify Listings
 * Configuration page. Contains the data needed to render the page.
 *
 * @author Heesun Jun (hjun@yext.com)
 */
import {AltBrandNamesConfig, AltBrandNamesConfigJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/specifylistingconfiguration/data/altbrandnamesconfig';
import {ListingConfiguration, ListingConfigurationJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/specifylistingconfiguration/data/listingsconfiguration';
export class LoadListingsConfigurationResponse {
  /**
   * @param {{
   *  alternateBrandNames: !Array<AltBrandNamesConfig>,
   *  existingConfig: (ListingConfiguration | undefined),
   * }} params
   */
  constructor(params) {
    /** @type {Array<AltBrandNamesConfig>} */
    this.alternateBrandNames = params.alternateBrandNames;
    /** @type {ListingConfiguration | undefined} */
    this.existingConfig = params.existingConfig;
  }

  /**
   * @param {!LoadListingsConfigurationResponseJson} json
   * @return {!LoadListingsConfigurationResponse}
   */
  static fromJSON(json) {
    return new LoadListingsConfigurationResponse({
      alternateBrandNames: json['altBrandNames'].map(AltBrandNamesConfig.fromJSON),
      existingConfig: json['listingConfiguration'] !== undefined
        ? ListingConfiguration.fromJSON(json['listingConfiguration'])
        : undefined,
    });
  }
}

/**
 * @dict
 * @typedef {{
*  alternateBrandNames: !Array<AltBrandNamesConfigJson>,
*  existingConfig : (ListingConfigurationJson | undefined),
* }}
*/
export var LoadListingsConfigurationResponseJson;
